import React from 'react'
import { PageProperties, Review, ServiceDescription } from '../types'
import './Landing.css'
import { separator } from '../App'

const Landing = ({ page }: PageProperties) => {

  // const separator = <hr style={{ background: "#232043", height: 1.5 }} />

  return (
    <div
      className="view"
      style={{
        padding: '10%',
        color: page.textColor || page.menu.color,
        background: `linear-gradient(${page.gradient?.direction}, ${page.gradient?.first}, ${page.gradient?.second})`
      }}
    >
      <div className="is-size-1 title forceBlack boldFontFamily">
        {page.title}
      </div>
      <div className="is-size-4 forceBlack" style={{lineHeight: 1.3}}>
        {page.subtitle}
        {page.subtitle2 && (<><br />{page.subtitle2}</>)}
      </div>
      {/* <hr style={{ backgroundColor: page.textColor }} /> */}
      <div style={{ paddingTop: 18 }}>
        {page.content.services?.map((s: ServiceDescription, i: number) => (
          <div key={i} className="is-size-3">
            <strong>{s.title}</strong>
            <br />
            <ul>
              {s.list.map((i: { name: string, description: string }, idx: number) => (
                <li key={idx} className="tighten is-size-5"><strong>{i.name}</strong> : {i.description} </li>)
              )}
            </ul>
            {page.content.services && i < page.content.services.length - 1 && (
              separator
            )}
          </div>

        ))}
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
          <button
            type="button"
            style={{ marginLeft: 40, minWidth: 240, display: "flex", flexWrap: "nowrap", background: '#232043', color: 'yellow' }}
            onClick={() => window.location.href = '/reserve'}
          >
            <i
              className=""
              aria-hidden="true"
              style={{ background: "yellow", borderRadius: 4, padding: "0.25rem", width: "1.15rem", height: "1.15rem", display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "nowrap" }}>
              <span className="forceBlack" style={{ fontStyle: 'normal', fontSize: "0.85rem", paddingLeft: 2 }}>P</span>
            </i>
            <span style={{ letterSpacing: 1.5 }}><strong style={{ color: "yellow" }}>&nbsp;&nbsp;Available Spaces</strong></span>
          </button>
        </div>
        {separator}
        {page.content.reviews?.length && (
          <div>
            <div style={{ marginBottom: 20 }} className="is-size-3 boldFontFamily">
              Testimonials
            </div>
            <div className="testimonials">
              {page.content.reviews?.map((r: Review, i: number) => {
                return (
                  <div key={i} style={{ flex: 0.32, height: 150 }}>
                    <div>
                      <div className="is-size-5 is-italic tighten">
                        "{r.text}"
                        <p />
                        <span className="is-size-6"><strong>★★★★★  {` -${r.author}`}</strong></span>
                      </div>
                    </div>
                  </div>
                )
              }
              )}
            </div>
          </div>
        )}
        <div className="logo-row">
          {/* {
            page.content.iconList?.map((icon) => (
              <div
                className="fv-social-icon"
                key={icon.name}
                onClick={() => window.open(icon.link)}
              >
                <i className={icon.name} />
              </div>
            ))
          } */}

        </div>
        {/* eSignatures form */}
        {/* <iframe
              style={{ width: "80%", height: "100vh" }}
              src="https://esignatures.io/sign/5e78dddd-bf85-4ddd-9853-a8b54b83d695?embedded=yes"
            /> */}
      </div>
    </div >
  )
}

export default Landing;